import React, { useState, useEffect } from 'react';
import './App.css';
import { HelmetProvider } from 'react-helmet-async';
import SEO from './components/SEO/SEO';
import Home from './components/Home/Home';
import Navigation from './components/Navigation/Navigation';
import logo from './components/Assets/logo.png'
import Contact from './components/Contact/Contact';
import About from './components/About/About';
import Exhibitions from './components/Exhibitions/Exhibitions'
import Projects from './components/Projects/Projects'
import Blocks from './components/Blocks/Blocks';
import Slabs from './components/Slabs/Slabs'

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [language, setLanguage] = useState('en');
  const [isLoading, setIsLoading] = useState(true);

  const getPageSEO = () => {
    switch(currentPage) {
      case 'blocks':
        return {
          title: 'Norwegian Wood Grain Quartzite Blocks | PA Global Collab',
          description: 'Premium Norwegian Wood Grain, Brazilian Wood Grain, Teak Wood Quartzite blocks direct from Raisen mine India.',
          keywords: 'norwegian wood grain, brazilian wood grain, teak wood quartzite, natural stone blocks'
        };
      case 'slabs':
        return {
          title: 'Premium Quartzite Slabs | Wood Pattern Stone | PA Global Collab',
          description: 'Luxury quartzite slabs with natural wood grain patterns. Factory direct prices.',
          keywords: 'quartzite slabs, wood pattern slabs, natural stone slabs'
        };
      default:
        return {
          title: 'Norwegian Wood Grain Quartzite | Brazilian Teak Wood Pattern Stone | PA Global Collab',
          description: 'Premium Norwegian Wood Grain quartzite blocks direct from Raisen mine India.',
          keywords: 'norwegian wood grain, quartzite blocks, natural stone'
        };
    }
  };

  useEffect(() => {
    // Simulate initial load
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  // Scroll to top whenever page changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth' // Use 'instant' for immediate scroll, or 'smooth' for animated scroll
    });
  }, [currentPage]); // This effect runs whenever currentPage changes

  const renderPage = () => {
    switch(currentPage) {
      case 'home':
        return <Home language={language} setCurrentPage={setCurrentPage} />;
      case 'blocks':
        return <Blocks language={language} setCurrentPage={setCurrentPage} />;
      case 'slabs':
        return <Slabs language={language} setCurrentPage={setCurrentPage} />;
      case 'contact':
        return <Contact language={language} setCurrentPage={setCurrentPage} />;
      case 'about':
        return <About language={language} setCurrentPage={setCurrentPage} />;
      case 'exhibitions':
        return <Exhibitions language={language} setCurrentPage={setCurrentPage} />;
      case 'projects':
        return <Projects language={language} setCurrentPage={setCurrentPage} />;
      default:
        return <Home language={language} setCurrentPage={setCurrentPage} />;
    }
  };

  if (isLoading) {
    return (
      <div className="loader-container">
        <div className="loader">
          <div className="loader-logo">
            {/* Replace src with your actual logo path */}
            <img src={logo} alt="PA Global Collab" />
          </div>
          {/* Fallback text if logo doesn't load */}
          {/* <div className="loader-text">PA GLOBAL COLLAB</div> */}
          <div className="loader-bar"></div>
        </div>
      </div>
    );
  }

  return (
    <HelmetProvider>
      <div className="App">
        <SEO {...getPageSEO()} />
        <Navigation 
          setCurrentPage={setCurrentPage} 
          currentPage={currentPage}
          language={language}
          setLanguage={setLanguage}
        />
        <main className="main-content">
          {renderPage()}
        </main>
      </div>
    </HelmetProvider>
  );
}

export default App;